import { Alert, AlertProps } from 'antd';
import styled from 'styled-components';

export const StyledAlert = styled(Alert)<AlertProps>`
  margin: ${({ theme }) => `${theme.spacing.space_2} 0`};
  font-size: ${({ theme }) => theme.font.size.medium};
  display: flex;
  align-items: center;
  flex-flow: row nowrap;

  .ant-alert-message {
    .title {
      font-weight: bold;
      margin-bottom: ${({ theme }) => theme.spacing.space_1};
      display: block;
    }
  }
`;

interface ClickableTextProps {
  onClick?: () => void;
}

export const ClickableText = styled.span<ClickableTextProps>`
  cursor: pointer;
  color: #0073bb;
  &:hover {
    text-decoration: underline;
  }
`;
